'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/tag.ts
var TAG_QUERY = `
 title
 slug
 id
 background{${IMAGE_QUERY}}
 icon{${IMAGE_QUERY}}
`;

export {
  TAG_QUERY
};
//# sourceMappingURL=chunk-TT4DXTR5.mjs.map